import { useQuery } from '@apollo/client'

import {
  ITEM_WEIGHT_QUERY,
  TOTAL_DELIVERY_PRICE_QUERY
} from './delivery-price.graphql'
import {
  DeliveryPriceApi,
  GetItemWeight,
  GetItemWeightData,
  GetTotalDeliveryPrice,
  GetTotalDeliveryPriceData,
  ItemWeightVariables,
  TotalDeliveryPriceVariables
} from './delivery.types'

// our "constructor"
export const deliveryService = (): DeliveryPriceApi => {
  const useItemWeight = (variables: ItemWeightVariables): GetItemWeight => {
    const { data, loading, error, refetch } = useQuery<
      GetItemWeightData,
      ItemWeightVariables
    >(ITEM_WEIGHT_QUERY, {
      variables
    })

    if (error) {
      return { data: null, loading, refetch }
    }

    if (!data) {
      return { data: null, loading, refetch }
    }

    return { data, loading, refetch }
  }

  const useTotalDeliveryPrice = (
    variables: TotalDeliveryPriceVariables
  ): GetTotalDeliveryPrice => {
    const { data, loading, error, refetch } = useQuery<
      GetTotalDeliveryPriceData,
      TotalDeliveryPriceVariables
    >(TOTAL_DELIVERY_PRICE_QUERY, {
      variables
    })

    if (error) {
      return { data: null, loading, refetch }
    }

    if (!data) {
      return { data: null, loading, refetch }
    }

    return { data, loading, refetch }
  }

  return {
    useItemWeight,
    useTotalDeliveryPrice
  }
}
